/* ================= Renderer / scene ================= */
var container = document.querySelector('.hero__model-container');
function repodIsCoarsePointerDevice() {
  return (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) || window.innerWidth < 768;
}

function repodGetRendererPixelRatioCap() {
  // The Banner canvas extends well beyond the visible model, so full Retina
  // density spends a lot of GPU time on transparent pixels. Keep it crisp
  // while trimming the backing buffer; the lower presentation stays at 2x.
  return repodIsCoarsePointerDevice() ? 1.25 : 1.6;
}

var renderer=new THREE.WebGLRenderer({antialias:true,alpha:true});
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, repodGetRendererPixelRatioCap()));
if(container) renderer.setSize(container.clientWidth, container.clientHeight);
renderer.outputEncoding=THREE.sRGBEncoding;
renderer.toneMapping=THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure=1.04; // lift the model while preserving the brightest metal highlights
renderer.shadowMap.enabled=true;
renderer.shadowMap.type=THREE.PCFSoftShadowMap;
renderer.setClearColor(0x000000,0);
if(container) container.appendChild(renderer.domElement);

var scene=new THREE.Scene();
var camera=new THREE.PerspectiveCamera(38, container ? container.clientWidth/container.clientHeight : 1, 0.5, 80);

/* ================= 💡 Core upgrade: dark, high-contrast studio environment map ================= */
/* Replaces the bright sky sphere with a dark gray / black studio.
   A few very bright softbox strips create sharp silver reflections along metal edges and bevels. */
(function(){
  var c=document.createElement('canvas'); c.width=1024; c.height=512;
  var x=c.getContext('2d');
  
  // Background gradient from deep steel gray to black for a clean reflective dark field.
  var g=x.createLinearGradient(0,0,0,512);
  g.addColorStop(0,'#3a3d44'); 
  g.addColorStop(0.25,'#1b1c1e'); 
  g.addColorStop(0.7,'#090a0c'); 
  g.addColorStop(1,'#020203');
  x.fillStyle=g; x.fillRect(0,0,1024,512);
  
  // Add bright soft sources to mimic overhead and angled studio softboxes.
  x.shadowColor='rgba(255,255,255,1.0)'; x.shadowBlur=60;
  x.fillStyle='rgba(255,255,255,0.98)';
  x.fillRect(180,40,240,75); 
  x.fillRect(650,90,220,70); 
  
  // Simulate narrow vertical strip reflections for crisp metal-edge highlights.
  x.shadowBlur=0;
  x.fillStyle='rgba(255,255,255,0.65)';
  x.fillRect(120,0,60,512);    // left reflection band
  x.fillRect(500,0,110,512);   // center reflection band
  x.fillRect(880,0,50,512);    // right reflection band
  
  var t=new THREE.CanvasTexture(c); t.mapping=THREE.EquirectangularReflectionMapping;
  var p=new THREE.PMREMGenerator(renderer); p.compileEquirectangularShader();
  scene.environment=p.fromEquirectangular(t).texture;
  t.dispose(); p.dispose();
})();

/* ================= Lighting, tuned for a brighter sculpted studio look ================= */
// Keep the ambient base controlled, but lift the dark-facing surfaces enough to retain detail.
scene.add(new THREE.HemisphereLight(0xffffff,0x2c3038,0.40));

var repodKeyLight=new THREE.DirectionalLight(0xffffff,1.28);
repodKeyLight.position.set(6,9,8); repodKeyLight.castShadow=true;
repodKeyLight.shadow.mapSize.set(repodIsCoarsePointerDevice() ? 1024 : 2048, repodIsCoarsePointerDevice() ? 1024 : 2048);
repodKeyLight.shadow.camera.left=-8; repodKeyLight.shadow.camera.right=8;
repodKeyLight.shadow.camera.top=8; repodKeyLight.shadow.camera.bottom=-8;
repodKeyLight.shadow.camera.near=1; repodKeyLight.shadow.camera.far=30;
repodKeyLight.shadow.bias=-0.0004; repodKeyLight.shadow.normalBias=0.02;
scene.add(repodKeyLight);

var repodFillLight=new THREE.DirectionalLight(0xeef4ff,0.52); repodFillLight.position.set(-6,2,5); scene.add(repodFillLight);
var repodFrontFillLight=new THREE.DirectionalLight(0xfffaf5,0.42); repodFrontFillLight.position.set(0,3.5,8.5); scene.add(repodFrontFillLight);
var repodRimLight=new THREE.DirectionalLight(0xffffff,0.82); repodRimLight.position.set(-1,5,-7); scene.add(repodRimLight);

// Low warm bounce reveals the wheel and lower chassis; the cool side accent separates the left edge.
var repodLowerBounceLight=new THREE.DirectionalLight(0xffe2cc,0.22);
repodLowerBounceLight.position.set(3,-4,6);
scene.add(repodLowerBounceLight);

var repodSideAccentLight=new THREE.DirectionalLight(0xdceaff,0.18);
repodSideAccentLight.position.set(-5,1,-2);
scene.add(repodSideAccentLight);

/* ================= Upgrade: high-resolution fine-grain sandblasted metal bump map ================= */
var bumpTex = (function createSandblastTexture() {
  var c = document.createElement('canvas');
  c.width = 512;
  c.height = 512;
  var ctx = c.getContext('2d');
  ctx.fillStyle = '#808080'; 
  ctx.fillRect(0, 0, 512, 512);
  
  var img = ctx.getImageData(0, 0, 512, 512);
  var data = img.data;
  for (var i = 0; i < data.length; i += 4) {
    var noise1 = (Math.random() - 0.5) * 18; 
    var noise2 = Math.sin(Math.floor(i / 1024) * 8) * 3;
    var n = clamp(128 + noise1 + noise2, 0, 255);
    data[i] = n;
    data[i+1] = n;
    data[i+2] = n;
  }
  ctx.putImageData(img, 0, 0);
  
  var t = new THREE.CanvasTexture(c);
  t.wrapS = THREE.RepeatWrapping;
  t.wrapT = THREE.RepeatWrapping;
  t.repeat.set(32, 48); 
  t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return t;
})();

/* ================= 💡 Core upgrade: rebuilt physical metal material parameters ================= */
// 1. Satin anodized aluminum body material, space silver
var matBody = new THREE.MeshPhysicalMaterial({
  color: 0x8a909a,              // 🌟 lower the base color to mid-gray so reflections define the surface
  metalness: 1.0,               // 🌟 full physical metalness; light and reflections drive the values
  roughness: 0.33,              // 🌟 lower roughness for tighter, sharper highlight shapes
  bumpMap: bumpTex,
  bumpScale: 0.003,            
  envMapIntensity: 2.2,         // strong environment reflection keeps softbox highlights bright on the dark base
  clearcoat: 0.16,              // light clearcoat adds liquid-like edge reflections
  clearcoatRoughness: 0.35
});

// 2. Realistic matte silver Click Wheel material
var matWheel = new THREE.MeshPhysicalMaterial({
  color: 0x9aa0aa,              // darker base color
  roughness: 0.28,              // lower roughness for high-contrast precision-metal reflections
  metalness: 1.0,
  bumpMap: bumpTex,
  bumpScale: 0.0025,             
  envMapIntensity: 2.5,
  side: THREE.DoubleSide
});


// 3. Matte silver accessory details
var matSilver = new THREE.MeshPhysicalMaterial({
  color: 0x9096a0,              // darker base color
  metalness: 1.0,
  roughness: 0.30,
  bumpMap: bumpTex,
  bumpScale: 0.0025,
  envMapIntensity: 2.0
});

// 4. Other materials tuned to match
var matWhite = new THREE.MeshStandardMaterial({color:0xf5f6f8, metalness:0.05, roughness:0.42, envMapIntensity:0.9}); // matte white base

// Vivid matte orange-red
var matOrange = new THREE.MeshStandardMaterial({
  color: 0xe02d11,              
  metalness: 0.12,              
  roughness: 0.54,              
  bumpMap: bumpTex,             
  bumpScale: 0.003,
  envMapIntensity: 0.45, 
  emissive: 0x420800,           
  emissiveIntensity: 0.25
});

var matRecess = new THREE.MeshStandardMaterial({color:0xb7babf, metalness:0.85, roughness:0.55});
var matRingBg = new THREE.MeshStandardMaterial({color:0xc3c6ca, metalness:0.85, roughness:0.55});
var matBlackG = new THREE.MeshStandardMaterial({color:0x141417, metalness:0.5, roughness:0.45});
var matNavy   = new THREE.MeshStandardMaterial({color:0x12182e, metalness:0.6, roughness:0.35});
var matLens   = new THREE.MeshStandardMaterial({color:0x05070d, metalness:0.7, roughness:0.25});
var matCrystal= new THREE.MeshStandardMaterial({color:0x16161b, metalness:0.4, roughness:0.18, envMapIntensity:1.2});
var matDark   = new THREE.MeshStandardMaterial({color:0x1b1b1e, metalness:0.1, roughness:0.75});
var matSeam   = new THREE.MeshStandardMaterial({color:0x8e9196, metalness:0.4, roughness:0.60});
var matGray   = new THREE.MeshStandardMaterial({color:0x6e7176, metalness:0.3, roughness:0.60});
var matFrame  = new THREE.MeshStandardMaterial({color:0x202125, metalness:0.2, roughness:0.50});
var matSilicone = new THREE.MeshPhysicalMaterial({
  color: 0x000000,
  metalness: 0.0,
  roughness: 0.94,
  reflectivity: 0.08,
  envMapIntensity: 0.12,
  clearcoat: 0.015,
  clearcoatRoughness: 0.92
});
var matDot    = new THREE.MeshBasicMaterial({color:0xf5f6f8});
var matBlueHL = new THREE.MeshBasicMaterial({color:0x5d7fe0});
